if (!customElements.get('product-media-hotspots')) {
  customElements.define(
    'product-media-hotspots',
    class ProductMediaHotspots extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback () {
        this.hotspotEls = this.querySelectorAll('[data-product-media-hotspots-el="hotspot"]')
        this.closeEls = this.querySelectorAll('[data-product-media-hotspots-el="close-button"]')
        this.toggleEl = document.querySelector('[data-product-media-hotspots-external-el="toggle"]');

        this.setupListeners();
      }

      setupListeners() {
        this.hotspotEls.forEach((hotspot) => {
          hotspot.addEventListener('click', this.handleHotspot.bind(this));
        });

        this.closeEls.forEach((button) => {
          button.addEventListener('click', this.closeHotspot.bind(this));
        });

        if (this.toggleEl) {
          this.toggleEl.addEventListener('change', this.toggleHotspots.bind(this));
        }
      }

      handleHotspot() {
        this.hotspotEls.forEach((hotspot) => {
          if (hotspot.parentElement().hasAttribute('open')) {
            hotspot.parentElement().removeAttribute('open');
          }
        });
      }

      closeHotspot(event) {
        const button = event.currentTarget;
        const parentDetails = button.closest('details');

        if (parentDetails) {
          parentDetails.removeAttribute('open');
        }
      }

      toggleHotspots() {
        this.toggleEl.setAttribute('aria-checked', this.toggleEl.getAttribute('aria-checked') === 'true' ? 'false' : 'true');

        console.log(this.toggleEl.querySelector('[data-text]'))
        this.toggleEl.querySelector('[data-text]').textContent = this.toggleEl.getAttribute('aria-checked') === 'false' ? this.toggleEl.getAttribute('data-hide-text') : this.toggleEl.getAttribute('data-show-text');

        this.setAttribute('aria-hidden' , this.toggleEl.getAttribute('aria-checked') === 'false' ? 'false' : 'true');
      }
    }
  );
}
